import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getStorage } from "firebase/storage";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getDatabase } from "firebase/database";

export const firebaseConfig = {
  apiKey: "AIzaSyBxsknzkioPR-prioplErQnawKnbBl_nsE",
  authDomain: "emas-2da35.firebaseapp.com",
  databaseURL: "https://emas-2da35-default-rtdb.firebaseio.com",
  projectId: "emas-2da35",
  storageBucket: "emas-2da35.appspot.com",
  messagingSenderId: "142530475111",
  appId: "1:142530475111:web:6b96efc4f9f98a9080d0c2"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const appCheck = initializeAppCheck(app, 
  {
    provider: new ReCaptchaEnterpriseProvider("6LeEVbIpAAAAAJ4xTBIkLlu2tG02y1RWd-5lPeJB"),
    isTokenAutoRefreshEnabled: true // Set to true to allow auto-refresh.
}
);


export const auth = getAuth(app);
export const db = getFirestore(app)
export const methods = {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut
}

export const storage = getStorage(app, app.storageBucket);
export const database = getDatabase();

export default app



